var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CardContent, Typography } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { DotList } from '..';
import { FlatChip, CourseImage, CourseIcon, SkillImage, BasicSkillIcon, CollectionImage } from '../../..';
const StyledCardContent = styled(CardContent) `
    padding: 16px !important;
    height: 120px;
`;
const CardContentContainer = styled.div `
    display: flex;
    height: 100%;
`;
const MainCardContentContainer = styled.div `
    align-self: flex-start;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-self: stretch;
`;
const CardContentImageContainer = styled.div `
    margin-right: 1rem;
    align-self: center;
`;
const UpperContentContainer = styled.div `
    display: flex;
`;
const TitleContainer = styled.div `
    flex: 1;
    height: 40px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;

    p {
        line-height: normal;
        color: ${(props) => props.theme.colors.text};
        overflow: hidden;
    }
`;
const FlatChipsContainer = styled.div `
    display: flex;
    flex: 1;
    align-self: center;
    height: 18px;
    color: ${(props) => props.theme.colors.textTertiary};
`;
const QuickActionsContainer = styled.div `
    display: flex;
`;
const LowerContentContainer = styled.div `
    display: flex;
    align-items: center;
`;
const SecondaryInfoContainer = styled.div `
    display: flex;
    flex: 1;
    align-items: flex-end;
`;
const TertiaryInfoContainer = styled.div `
    display: flex;
    flex: 1;
    align-items: flex-end;
`;
const SecondaryInfoIconsContainer = styled.div `
    margin-left: 1rem;
    display: flex;
    align-self: center;
`;
const FlexInfoContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
const StyledLowerRightContainer = styled.div `
    margin-left: auto;
`;
const AdeptCardContent = (_a) => {
    var { children, contentImageComponent, contentTypeComponent, organizationComponent, quickActionsComponent, title, secondaryInfo, tertiaryInfo, secondaryInfoIconsComponent, lowerRightComponent } = _a, otherProps = __rest(_a, ["children", "contentImageComponent", "contentTypeComponent", "organizationComponent", "quickActionsComponent", "title", "secondaryInfo", "tertiaryInfo", "secondaryInfoIconsComponent", "lowerRightComponent"]);
    const renderFlatChipsDotList = () => {
        if (contentTypeComponent || organizationComponent) {
            return (React.createElement(DotList, null,
                contentTypeComponent,
                organizationComponent));
        }
        return null;
    };
    const renderQuickActions = () => {
        if (quickActionsComponent) {
            return React.createElement(QuickActionsContainer, null, quickActionsComponent);
        }
        return null;
    };
    const renderSecondaryInfo = () => {
        if (secondaryInfo) {
            return (React.createElement(Typography, { variant: "body2", component: "div" },
                React.createElement(DotList, null, secondaryInfo)));
        }
        return null;
    };
    const renderSecondaryInfoIcons = () => {
        if (secondaryInfoIconsComponent) {
            return React.createElement(SecondaryInfoIconsContainer, null, secondaryInfoIconsComponent);
        }
        return null;
    };
    const renderTertiaryInfo = () => {
        if (tertiaryInfo) {
            return (React.createElement(Typography, { variant: "body2", component: "div" },
                React.createElement(DotList, null, tertiaryInfo)));
        }
        return null;
    };
    const renderLowerRightComponent = () => {
        if (lowerRightComponent) {
            return lowerRightComponent;
        }
        return null;
    };
    return (React.createElement(StyledCardContent, Object.assign({}, otherProps),
        React.createElement(CardContentContainer, null,
            React.createElement(CardContentImageContainer, null, contentImageComponent),
            React.createElement(MainCardContentContainer, null,
                React.createElement(UpperContentContainer, null,
                    React.createElement(FlatChipsContainer, null, renderFlatChipsDotList()),
                    renderQuickActions()),
                React.createElement(TitleContainer, null,
                    React.createElement(Typography, { variant: "subtitle1", component: "p" }, title)),
                React.createElement(LowerContentContainer, null,
                    React.createElement(FlexInfoContainer, null,
                        React.createElement(SecondaryInfoContainer, null,
                            renderSecondaryInfo(),
                            renderSecondaryInfoIcons()),
                        React.createElement(TertiaryInfoContainer, null, renderTertiaryInfo())),
                    React.createElement(StyledLowerRightContainer, null, renderLowerRightComponent())))),
        children));
};
const AdeptCardContentCourse = (_a) => {
    var { imageProps } = _a, otherProps = __rest(_a, ["imageProps"]);
    return (React.createElement(AdeptCardContent, Object.assign({ contentImageComponent: React.createElement(CourseImage.Medium, Object.assign({}, imageProps)), contentTypeComponent: React.createElement(FlatChip.UppercaseTertiary, { icon: React.createElement(CourseIcon, null), label: "Course" }) }, otherProps)));
};
const AdeptCardContentSkill = (_a) => {
    var { imageProps, showContentTypeComponent = true } = _a, otherProps = __rest(_a, ["imageProps", "showContentTypeComponent"]);
    return (React.createElement(AdeptCardContent, Object.assign({ contentImageComponent: React.createElement(SkillImage.Medium, Object.assign({}, imageProps)), contentTypeComponent: showContentTypeComponent ? React.createElement(FlatChip.UppercaseTertiary, { icon: React.createElement(BasicSkillIcon, null), label: "Skill" }) : null }, otherProps)));
};
const SharedCSS = css `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background-color: ${(props) => props.theme.colors.surface};
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 4px;
    transition: transform 0.15s, border 0.15s, box-shadow 0.15s, width 0.15s;
`;
const BottomCard = styled.div `
    ${SharedCSS}
    width: calc(100% - 16px);
    transform: translate(8px, -8px);
`;
const MiddleCard = styled.div `
    ${SharedCSS}
    width: calc(100% - 8px);
    transform: translate(4px, -4px);
`;
const CollectionsCardContainer = styled.div `
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 100%;

    &:hover {
        ${BottomCard}, ${MiddleCard} {
            width: 100%;
            transform: translate(0px, 0px);
        }
    }
`;
const CollectionsCardContent = styled(AdeptCardContent) `
    position: relative;
    height: 100%;
    background-color: ${(props) => props.theme.colors.surface};
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 4px;
    transition: transform 0.15s, border 0.15s, box-shadow 0.15s, width 0.15s;
    z-index: 1;
    &:hover {
        cursor: pointer;
        background-color: ${(props) => props.theme.colors.surface};
        border: 1px solid ${(props) => props.theme.colors.white};
        box-shadow: 0 4px 5px 0 rgba(55, 71, 79, 0.14), 0 1px 10px 0 rgba(55, 71, 79, 0.12),
            0 2px 4px -1px rgba(55, 71, 79, 0.2);
    }
`;
const AdeptCardContentCollection = (_a) => {
    var { imageProps } = _a, otherProps = __rest(_a, ["imageProps"]);
    return (React.createElement(CollectionsCardContainer, null,
        React.createElement(BottomCard, null),
        React.createElement(MiddleCard, null),
        React.createElement(CollectionsCardContent, Object.assign({ contentImageComponent: React.createElement(CollectionImage.Medium, Object.assign({}, imageProps)) }, otherProps))));
};
AdeptCardContent.Course = AdeptCardContentCourse;
AdeptCardContent.Skill = AdeptCardContentSkill;
AdeptCardContent.Collection = AdeptCardContentCollection;
export default AdeptCardContent;
//# sourceMappingURL=AdeptCardContent.js.map